import React from "react";
import AddIcon from "../UIComponents/AddIcon";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  getServiceProviderList,
  putServiceProviderDetails,
  getPortAndCountry,
  getPortCountry,
} from "../Actions/ServiceProviderAPI";
import axios from "axios";
import API from "../helpers/api";
import $ from "jquery";
import { toast } from "react-toastify";
import Autocomplete from "react-autocomplete";
import swal from "sweetalert";


let currentuser = JSON.parse(localStorage.getItem("currentUser"));

let searchData = {
  ServiceProviderName: "",
  PageNumber: 1,
  PageSize: 20,
};
class EditService extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      serviceProviderId: 0,
      currentUser: JSON.parse(localStorage.getItem("currentUser")),
      serviceProviderName: "",
      mail: "",
      phone1: "",
      phone2: "",
      port: "",
      country: "",
      portId: 0,
      isDeleted: false,
      modifiedBy: currentuser.name,
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.UpdateServiceProvider = this.UpdateServiceProvider.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.handleInputChanges = this.handleInputChanges.bind(this);
    this.renderPortTitle = this.renderPortTitle.bind(this);
    this.renderCountryTitle = this.renderCountryTitle.bind(this);
  }

  componentDidMount() {
    let port = {
      port: "",
      country: "",
    };
    this.props.dispatch(getPortAndCountry(port));
    this.props.dispatch({ type: "SubBannerTitle", data: "Serviced By" })
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    const { ServiceProviderDetail, dispatch, PortCountry } = nextProps;
    if (ServiceProviderDetail && ServiceProviderDetail !== "") {
      prevState.serviceProviderId = ServiceProviderDetail.serviceProviderId;
      prevState.serviceProviderName = ServiceProviderDetail.serviceProviderName;
      prevState.mail = ServiceProviderDetail.email;
      prevState.phone1 = ServiceProviderDetail.phone1;
      prevState.phone2 = ServiceProviderDetail.phone2;
      prevState.port = ServiceProviderDetail.port;
      prevState.country = ServiceProviderDetail.country;
      dispatch({ type: "getServiceProviderDetailSuccess", data: "" });
    }
    if (PortCountry && PortCountry !== "") {
      prevState.port = PortCountry[0].port;
      prevState.country = PortCountry[0].country;
      dispatch({ type: "getPortCountrySuccess", data: "" });
    }
  }

  hideSidePanel() {
    // this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.goBack();
  }

  verify(){
    const{t}=this.props
    let flag=true;
    if(this.state.country=="" || this.state.port=="" || this.state.phone2==""|| this.state.phone1=="" || this.state.email=="" || this.state.serviceProviderName=="")
    {
      flag=false
      if(this.state.country=="")
      {
        $("#countryErr").text(t('ErrorMessage.RequiredMsg'))
      }
      else{
        $("#countryErr").text("")
      }
      if(this.state.port=="")
        {
          $("#portErr").text(t('ErrorMessage.RequiredMsg'))
        }
     else{
          $("#portErr").text("")
        }
     if(this.state.phone2=="")
          {
            $("#phone2Err").text(t('ErrorMessage.RequiredMsg'))
          }
      else{
            $("#phone2Err").text("")
          }
    if(this.state.phone1=="")
      {
        $("#phone1Err").text(t('ErrorMessage.RequiredMsg'))
      }
    else{
        $("#phone1Err").text("")
      }
    if(this.state.email=="")
        {
          $("#emailErr").text(t('ErrorMessage.RequiredMsg'))
        }
    else{
          $("#emailErr").text("")
        }  
    if(this.state.serviceProviderName=="")
          {
            $("#serviceProviderNameErr").text(t('ErrorMessage.RequiredMsg'))
          }
    else{
            $("#serviceProviderNameErr").text("")
          }    
}
    return flag
  }

  UpdateServiceProvider() {
    const { dispatch,t,PortList } = this.props;
    const validPorts = PortList.map(item => item.port);
    const vaildCountry = PortList.map(item=>item.country)
    
    if(this.verify()){
      if(validPorts.includes(this.state.port)){
        if(vaildCountry.includes(this.state.country)){
    
    let url = `${API.postServiceProvider}`;
    let data = {
      serviceProviderId: this.state.serviceProviderId,
      serviceProviderName: this.state.serviceProviderName,
      port: this.state.port,
      country: this.state.country,
      portId: this.state.portId,
      mail: this.state.mail,
      phone1: this.state.phone1,
      phone2: this.state.phone2,
      isDeleted: false,
      modifiedBy: this.state.currentUser.name,
    };
    axios
      .put(url, data)
      .then((response) => {
        dispatch(getServiceProviderList(searchData));
        this.hideSidePanel();
        toast.success(`${t("CommonText.CommonUpdate")}`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        dispatch({
          type: "putServiceProviderDetailSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "putServiceProviderDetailFailure",
          error: "ERROR",
        });
      });
    }
    else{
      swal({
        title: t('SwalError.ErrorTitle'),
        text: "Select valid country",
        icon: 'warning',
        buttons: {
          confirm: {
            text: t('confirmAlertMessage.Ok')
          }
        }
      });
     }
    }
       else{
        swal({
          title: t('SwalError.ErrorTitle'),
          text: "Select valid port",
          icon: 'warning',
          buttons: {
            confirm: {
              text: t('confirmAlertMessage.Ok')
            }
          }
        });
      }
    }
  }

  handleInputChange(e) {
    let nodeName = e.target.name;
    if (nodeName === "phone1") {
      const phone1 = e.target.validity.valid
        ? e.target.value
        : this.state.phone1;
      this.state[nodeName] = phone1;
      this.setState({});
    } else if (nodeName === "phone2") {
      const phone2 = e.target.validity.valid
        ? e.target.value
        : this.state.phone2;
      this.state[nodeName] = phone2;
      this.setState({});
    } else {
      this.setState({
        [nodeName]: e.target.value,
      });
    }
  }

  handlePortInputChange = (e) => {
    let nodeName = e.target.name;
    if (nodeName === "port") {
      this.state[nodeName] = e.target.value;
      this.state.country = "";
      this.setState({});
      this.props.dispatch(getPortCountry(this.state));
    } else if (nodeName === "country") {
      this.state[nodeName] = e.target.value;
      this.state.port = "";
      this.setState({});
      this.props.dispatch(getPortCountry(this.state));
    }
    this.setState({});
  };

  handleInputChanges(e, field) {
    this.state[field] = e.target.value;
    if (e.target.value === "" && field === "port") {
      this.state.country = "";
      this.setState({});
      this.props.dispatch(getPortAndCountry(this.state));
    }
    else {
      this.props.dispatch(getPortAndCountry(this.state));
    }

    this.setState({});
  }

  handleSelectChange(value, field, id, fieldId) {
    this.state[field] = value;
    this.state[fieldId] = id;
    this.props.dispatch(getPortAndCountry(this.state));
    this.setState({});
  }
  renderCountryTitle(state, val) {
    return state?.country?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
  }
  renderPortTitle(state, val) {
    return state?.port?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
  }

  render() {
    const {
      PortAndCountry,
      PortCountry,
      ServiceProviderPortList,
      PortList,
      CountryList,
      t
    } = this.props;
    return (
      <div className="full-height">
        <div className="resource-list-auth-date row pt-3 ">
          <div className="col-lg-12">
            <div className="panel-box search-filter-box">
              <div
                className="card mt-2 MM-card-header"
                style={{ backgroundColor: "white" }}
              >
                <div
                  className="card-body"
                  style={{
                    padding: "0rem",
                    backgroundColor: "#1a3464",
                    color: "white",
                  }}
                >
                  <h5
                    className="card-title ml-2 mt-2"
                    style={{ color: "092a51" }}
                  >
                   {t("ServicedByScreenContent.UpdateServiceProvider")}
                  </h5>
                </div>
              </div>
              <div className="row search-filter-box">
                <div className="col-lg-4">
                  <label className="form-label">{t("ShipDetailsScreen.ServiceProvider")}</label>
                  <br></br>
                  <input
                    type="text"
                    className="form-control"
                    name="serviceProviderName"
                    value={this.state.serviceProviderName}
                    placeholder={t("ShipDetailsScreen.ServiceProvider")}
                    onChange={(e) => this.handleInputChange(e)}
                  ></input>
                  <span id="serviceProviderNameErr" className="spanErrMsg"></span>
                </div>
                {/* <div className="col-lg-4">
                  <div className="autocomplete-wrappers">
                    <label className="form-label">Service Provider</label>
                    <br></br>
                    <Autocomplete
                      contentEditable={true}
                      value={this.state.serviceProviderName}
                      inputProps={{ placeholder: "Service Provider" }}
                      items={ServiceProviderPortList}
                      getItemValue={(item) => item.port}
                      shouldItemRender={this.renderPortTitle.bind(this)}
                      renderMenu={(item) => (
                        <div className="dropdown">{item}</div>
                      )}
                      renderItem={(item, isHighlighted) => (
                        <div
                          className={`items ${
                            isHighlighted ? "selected-items" : ""
                          }`}
                        >
                          {item.port}
                        </div>
                      )}
                      onChange={(e, field) =>
                        this.handleInputChanges(e, "serviceProviderName")
                      }
                      onSelect={(value) =>
                        this.handleSelectChange(value, "serviceProviderName")
                      }
                    />
                  </div>
                </div> */}
                <div className="col-lg-4">
                  <label className="form-label">{t("ServicedByScreenContent.Email")}</label>
                  <br></br>
                  <input
                    type="text"
                    className="form-control"
                    name="mail"
                    value={this.state.mail}
                    placeholder={t("ServicedByScreenContent.Email")}
                    onChange={(e) => this.handleInputChange(e)}
                  ></input>
                  <span id="emailErr" className="spanErrMsg"></span>
                </div>
                <div className="col-lg-4">
                  <label className="form-label">{t("ServicedByScreenContent.Phone1")}</label>
                  <br></br>
                  <input
                    type="text"
                    className="form-control"
                    pattern="[0-9]*"
                    name="phone1"
                    value={this.state.phone1}
                    placeholder={t("ServicedByScreenContent.Phone1")}
                    onChange={(e) => this.handleInputChange(e)}
                  ></input>
                  <span id="phone1Err" className="spanErrMsg"></span>
                </div>
                <div className="col-lg-4">
                  <label className="form-label">{t("ServicedByScreenContent.Phone2")}</label>
                  <br></br>
                  <input
                    type="text"
                    className="form-control"
                    pattern="[0-9]*"
                    name="phone2"
                    value={this.state.phone2}
                    placeholder={t("ServicedByScreenContent.Phone2")}
                    onChange={(e) => this.handleInputChange(e)}
                  ></input>
                  <span id="phone2Err" className="spanErrMsg"></span>
                </div>

                {/* <div className="col-lg-4">
                  <label className="form-label">Port</label>
                  <br></br>
                  <select
                    className="form-control"
                    name="port"
                    value={this.state.port}
                    onChange={(e) => this.handlePortInputChange(e)}
                  >
                    <option value="">Select Port</option>
                    {PortAndCountry &&
                      PortAndCountry.map((portName) => (
                        <option value={portName.port}>{portName.port}</option>
                      ))}
                  </select>
                </div> */}
                <div className="col-lg-4">
                  <div className="autocomplete-wrappers">
                    <label className="form-label">{t("TopPaneContent.Port")}</label>
                    <br></br>
                    <Autocomplete
                      contentEditable={true}
                      value={this.state.port ?? ""}
                      inputProps={{ placeholder: `${t("TopPaneContent.Port")}` }}
                      items={PortList}
                      getItemValue={(item) => item.port}
                      shouldItemRender={this.renderPortTitle.bind(this)}
                      renderMenu={(item) => (
                        <div className="dropdown">{item}</div>
                      )}
                      renderItem={(item, isHighlighted) => (
                        <div
                          className={`items ${
                            isHighlighted ? "selected-items" : ""
                          }`}
                        >
                          {item.port}
                        </div>
                      )}
                      onChange={(e, field) =>
                        this.handleInputChanges(e, "port")
                      }
                      onSelect={(value, item) =>
                        this.handleSelectChange(value, "port", item.portId, "portId")
                      }
                    />
                    <span id="portErr" className="spanErrMsg"></span>
                  </div>
                </div>
                {/* <div className="col-lg-4">
                  <label className="form-label">Country</label>
                  <br></br>
                  <select
                    className="form-control"
                    name="country"
                    value={this.state.country}
                    onChange={(e) => this.handlePortInputChange(e)}
                  >
                    <option value="">Select Country</option>
                    {PortAndCountry &&
                      PortAndCountry.map((portName) => (
                        <option value={portName.country}>
                          {portName.country}
                        </option>
                      ))}
                  </select>
                </div> */}
                <div className="col-lg-4">
                  {/* <label className="form-label">Country</label><br></br>
                                    <select className="form-control" name="country" value={this.state.country} onChange={e => this.handlePortInputChange(e)}>
                                        <option value="">Select Country</option>
                                        {PortAndCountry && PortAndCountry.map(portName => (
                                            <option value={portName.country}>{portName.country}</option>
                                        ))}
                                    </select> */}
                  <div className="autocomplete-wrappers">
                    <label className="form-label">{t("EquipmentServiceTypes.Country")}</label>
                    <br></br>
                    <Autocomplete
                      contentEditable={true}
                      value={this.state.country ?? ""}
                      inputProps={{ placeholder: `${t("EquipmentServiceTypes.Country")}` }}
                      items={CountryList}
                      getItemValue={(item) => item.country}
                      shouldItemRender={this.renderCountryTitle.bind(this)}
                      renderMenu={(item) => (
                        <div className="dropdown">{item}</div>
                      )}
                      renderItem={(item, isHighlighted) => (
                        <div
                          className={`items ${
                            isHighlighted ? "selected-items" : ""
                          }`}
                        >
                          {item.country}
                        </div>
                      )}
                      onChange={(e, field) =>
                        this.handleInputChanges(e, "country")
                      }
                      onSelect={(value) =>
                        this.handleSelectChange(value, "country")
                      }
                    />
                    <span id="countryErr" className="spanErrMsg"></span>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12 search-filter-box">
                  <div className="search-btn-col" style={{ textAlign: "end" }}>
                    <button
                      className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                      type="submit"
                      onClick={() => this.UpdateServiceProvider()}
                    >
                      {" "}
                      {t("EquipmentServiceTypes.Update")}{" "}
                    </button>

                    <button
                      className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                      type="button"
                      onClick={() => this.hideSidePanel()}
                    >
                      {" "}
                      {t("ComplianceandBudgetScreen.Cancel")}{" "}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    ServiceProviderDetail: state.MasterScreenReducer.ServiceProviderDetail,
    PortAndCountry: state.MasterScreenReducer.PortAndCountry,
    PortCountry: state.MasterScreenReducer.PortCountry,
    PortList: state.MasterScreenReducer.PortLists || [],
    CountryList: state.MasterScreenReducer.CountryList || [],
    ServiceProviderPortList:
      state.MasterScreenReducer.ServiceProviderPortList || [],
  };
}
export default withTranslation()(withRouter(
  connect(mapStateToProps, mapDispatchToProps)(EditService)));
